export type OverflowEdges = 'none' | 'top' | 'bottom' | 'both';

interface Metrics {
  scrollTop: number;
  scrollHeight: number;
  clientHeight: number;
}

// Absorbs sub-pixel scroll rounding so at-top/at-bottom register cleanly.
const THRESHOLD = 1;

/**
 * Which edges of a scroll container have hidden content — drives an edge-fade
 * that appears only where there's actually more to scroll (top, bottom, both,
 * or none when it fits).
 */
export function overflowEdges({ scrollTop, scrollHeight, clientHeight }: Metrics): OverflowEdges {
  const threshold = THRESHOLD;
  if (scrollHeight - clientHeight <= threshold) return 'none';
  const atTop = scrollTop <= threshold;
  const atBottom = scrollTop + clientHeight >= scrollHeight - threshold;
  if (atTop) return 'bottom';
  if (atBottom) return 'top';
  return 'both';
}
